import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=6c2dd066&scoped=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Result.vue?vue&type=style&index=0&id=6c2dd066&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6c2dd066",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2dd066')) {
      api.createRecord('6c2dd066', component.options)
    } else {
      api.reload('6c2dd066', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=6c2dd066&scoped=true", function () {
      api.rerender('6c2dd066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Result.vue"
export default component.exports